'use client'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Spinner,
} from '@repo/ui/components'
import { useMutation } from '@tanstack/react-query'
import { PropsWithChildren, useState } from 'react'

interface Props {
  asChild?: boolean
  callbackAction: () => Promise<void>
  deleteText: string
  description: string
  open?: boolean
  setOpen?: (open: boolean) => void
  title: string
}

export const DeleteModal = ({
  asChild = false,
  callbackAction,
  children,
  deleteText,
  description,
  open,
  setOpen,
  title,
}: PropsWithChildren<Props>) => {
  const [localOpen, setLocalOpen] = useState(false)

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      await callbackAction()
      setLocalOpen(false)
    },
  })

  return (
    <Dialog onOpenChange={setOpen || setLocalOpen} open={open || localOpen}>
      <DialogTrigger {...{ asChild }}>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader className={'gap-6 space-y-0'}>
          <DialogTitle className={'text-foreground'}>{title}</DialogTitle>
          <DialogDescription className={'text-foreground'}>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => setOpen?.(false) || setLocalOpen(false)} variant={'secondary'}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              mutate()
            }}
            variant={'destructive'}
          >
            {deleteText} {isPending && <Spinner />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
